module.exports = __webpack_public_path__ + "img/full6-min.11a7ddd3.png";